import { render, staticRenderFns } from "./main.roles.vue?vue&type=template&id=7da75720"
import script from "./main.roles.vue?vue&type=script&lang=js"
export * from "./main.roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports